<!-- 3D购物车SVG，带悬浮动画 -->
<template>
  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" class="cart-3d">
    <g filter="url(#shadow)">
      <rect x="20" y="40" width="80" height="40" rx="16" fill="#a3a3ff" fill-opacity="0.7"/>
      <rect x="30" y="30" width="60" height="40" rx="12" fill="#fff" fill-opacity="0.9"/>
      <ellipse cx="40" cy="85" rx="8" ry="8" fill="#4b2067"/>
      <ellipse cx="80" cy="85" rx="8" ry="8" fill="#4b2067"/>
      <rect x="50" y="20" width="20" height="20" rx="6" fill="#a3a3ff" fill-opacity="0.7"/>
    </g>
    <defs>
      <filter id="shadow" x="0" y="0" width="120" height="120" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="8" stdDeviation="8" flood-color="#4b2067" flood-opacity="0.25"/>
      </filter>
    </defs>
  </svg>
</template>

<script setup>
// 仅样式动画，无逻辑
</script>

<style scoped>
.cart-3d {
  animation: float-cart 3.5s ease-in-out infinite alternate;
  filter: drop-shadow(0 8px 24px #4b206755);
}
@keyframes float-cart {
  0% { transform: translateY(0) scale(1) rotate(-6deg); }
  50% { transform: translateY(-18px) scale(1.04) rotate(6deg); }
  100% { transform: translateY(0) scale(1) rotate(-6deg); }
}
</style>
